import { Button, radius } from '@alison/ui';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import type { AdProvider } from '../../lib/adNetwork.hooks.js';
import { NetworkMark } from './NetworkMark.js';
import { PROVIDER_DESCRIPTION, PROVIDER_LABEL } from './networks.js';

interface NetworkCardProps {
  provider: AdProvider;
  linkPending: boolean;
  onConnect: () => void;
}

export function NetworkCard({ provider, linkPending, onConnect }: NetworkCardProps): ReactNode {
  return (
    <Paper
      elevation={0}
      data-testid={`provider-card-${provider}`}
      sx={{
        p: 3,
        minHeight: 190,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: `${radius.xl}px`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 2,
        transition: 'border-color 150ms, box-shadow 150ms',
        '&:hover': { borderColor: 'primary.light', boxShadow: 1 },
      }}
    >
      <NetworkMark provider={provider} size={40} />
      <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{PROVIDER_LABEL[provider]}</Typography>
      <Typography sx={{ flex: 1, color: 'text.secondary' }}>
        {PROVIDER_DESCRIPTION[provider]}
      </Typography>
      <Button
        variant="outlined"
        size="small"
        fullWidth
        data-testid={`connect-${provider}`}
        disabled={linkPending}
        onClick={onConnect}
      >
        {linkPending ? 'Redirecting…' : 'Connect'}
      </Button>
    </Paper>
  );
}
